const SET_CHAT_IS_LOADED = 'SET_CHAT_IS_LOADED';
const SET_CHAT_VISIBILITY = 'SET_CHAT_VISIBILITY';

export { SET_CHAT_IS_LOADED, SET_CHAT_VISIBILITY };
